
import { Component, Provide, Vue } from 'vue-property-decorator';
import ContentPageRepository from '@/repositories/content/ContentPageRepository';
import ContentPageTranslationRepository from '@/repositories/content/ContentPageTranslationRepository';
import FileRepository from '@/repositories/upload/FileRepository';
import {
    contentPageRepository,
    contentPageTranslationRepository,
    directNavigationItemRepository,
    directNavigationItemTranslationRepository,
    fileRepository,
    globalState,
    labelRepository,
    libraryItemRepository,
    libraryItemTranslationRepository,
    navigationItemRepository,
    navigationItemTranslationRepository,
    orderRepository,
    productCategoryRepository,
    productImageRepositroy,
    productOrderRepository,
    productRepository,
    productTranslationRepository,
    productInventoryRepository,
    rowRepository,
    rowTranslationRepository,
    subNavigationItemRepository,
    subNavigationItemTranslationRepository,
    weeklySignRepository,
    weeklySignTranslationRepository,
    ngtMediaRepository,
    shopHeaderRepository,
    footerRepository,
    footerLinkRepository,
    employeeRepository,
    employeeTranslationRepository,
    rowPageRepository,
    couponRepository,
    accountViewRepository, frontPageContentRepository,
} from '@/container';
import GlobalState from '@/util/GlobalState';
import { Subscription } from 'rxjs';
import LabelRepository from '@/repositories/content/label/LabelRepository';
import RowRepository from '@/repositories/content/row/RowRepository';
import RowTranslationRepository from '@/repositories/content/row/RowTranslationRepository';
import RowPageRepository from '@/repositories/content/row/RowPageRepository';
import DirectNavigationItemRepository from '@/repositories/directnavigation/DirectNavigationItemRepository';
import DirectNavigationItemTranslationRepository from '@/repositories/directnavigation/DirectNavigationItemTranslationRepository';
import NavigationItemRepository from '@/repositories/sidebar/NavigationItemRepository';
import NavigationItemTranslationRepository from '@/repositories/sidebar/NavigationItemTranslationRepository';
import SubNavigationItemRepository from '@/repositories/sidebar/SubNavigationItemRepository';
import SubNavigationItemTranslationRepository from '@/repositories/sidebar/SubNavigationItemTranslationRepository';
import WeeklySignRepository from '@/repositories/WeeklySign/WeeklySignRepository';
import WeeklySignTranslationRepository from '@/repositories/WeeklySign/WeeklySignTranslationRepository';
import OrderRepository from '@/repositories/webshop/OrderRepository';
import ProductRepository from '@/repositories/webshop/ProductRepository';
import ProductTranslationRepository from '@/repositories/webshop/ProductTranslationRepository';
import ProductCategoryRepository from '@/repositories/webshop/ProductCategoryRepository';
import ProductOrderRepository from '@/repositories/webshop/ProductOrderRepository';
import LibraryItemRepository from '@/repositories/libraryitem/LibraryItemRepository';
import LibraryItemTranslationRepository from '@/repositories/libraryitem/LibraryItemTranslationRepository';
import ProductImageRepository from '@/repositories/webshop/ProductImageRepository';
import NgtMediaRepository from '@/repositories/NgtMediaRepository';
import ShopHeaderRepository from '@/repositories/content/ShopHeaderRepository';
import FooterRepository from '@/repositories/content/FooterRepository';
import FooterLinkRepository from '@/repositories/content/FooterLinkRepository';
import EmployeeRepository from '@/repositories/employees/EmployeeRepository';
import EmployeeTranslationRepository from '@/repositories/employees/EmployeeTranslationRepository';
import CouponRepository from '@/repositories/webshop/CouponRepository';
import ProductInventoryRepository from '@/repositories/webshop/ProductInventoryRepository';
import AccountViewRepository from '@/repositories/accountview/AccountViewRepository';
import FrontPageContentRepository from "@/repositories/content/FrontPageContentRepository";

@Component
export default class App extends Vue {
    @Provide()
    public contentPageRepository: ContentPageRepository = contentPageRepository;

    @Provide()
    public couponRepository: CouponRepository = couponRepository;

    @Provide()
    public contentPageTranslationRepository: ContentPageTranslationRepository = contentPageTranslationRepository;

    @Provide()
    public fileRepository: FileRepository = fileRepository;

    @Provide()
    public labelRepository: LabelRepository = labelRepository;

    @Provide()
    public frontPageContentRepository: FrontPageContentRepository = frontPageContentRepository;

    @Provide()
    public rowRepository: RowRepository = rowRepository;

    @Provide()
    public rowTranslationRepository: RowTranslationRepository = rowTranslationRepository;

    @Provide()
    public rowPageRepository: RowPageRepository = rowPageRepository;

    @Provide()
    public directNavigationItemRepository: DirectNavigationItemRepository = directNavigationItemRepository;

    @Provide()
    public directNavigationItemTranslationRepository: DirectNavigationItemTranslationRepository =
        directNavigationItemTranslationRepository;

    @Provide()
    public navigationItemRepository: NavigationItemRepository = navigationItemRepository;

    @Provide()
    public navigationItemTranslationRepository: NavigationItemTranslationRepository =
        navigationItemTranslationRepository;

    @Provide()
    public subNavigationItemRepository: SubNavigationItemRepository = subNavigationItemRepository;

    @Provide()
    public subNavigationItemTranslationRepository: SubNavigationItemTranslationRepository =
        subNavigationItemTranslationRepository;

    @Provide()
    public weeklySignRepository: WeeklySignRepository = weeklySignRepository;

    @Provide()
    public weeklySignTranslationRepository: WeeklySignTranslationRepository = weeklySignTranslationRepository;

    @Provide()
    public orderRepository: OrderRepository = orderRepository;

    @Provide()
    public productRepository: ProductRepository = productRepository;

    @Provide()
    public productTranslationRepository: ProductTranslationRepository = productTranslationRepository;

    @Provide()
    public productCategoryRepository: ProductCategoryRepository = productCategoryRepository;

    @Provide()
    public productOrderRepository: ProductOrderRepository = productOrderRepository;

    @Provide()
    public productImageRepository: ProductImageRepository = productImageRepositroy;

    @Provide()
    public productInventoryRepository: ProductInventoryRepository = productInventoryRepository;

    @Provide()
    public libraryItemRepository: LibraryItemRepository = libraryItemRepository;

    @Provide()
    public libraryItemTranslationRepository: LibraryItemTranslationRepository = libraryItemTranslationRepository;

    @Provide()
    public ngtMediaRepository: NgtMediaRepository = ngtMediaRepository;

    @Provide()
    public shopHeaderRepository: ShopHeaderRepository = shopHeaderRepository;

    @Provide()
    public footerRepository: FooterRepository = footerRepository;

    @Provide()
    public footerLinkRepository: FooterLinkRepository = footerLinkRepository;

    @Provide()
    public employeeRepository: EmployeeRepository = employeeRepository;

    @Provide()
    public employeeTranslationRepository: EmployeeTranslationRepository = employeeTranslationRepository;

    @Provide()
    public accountViewRepository: AccountViewRepository = accountViewRepository;

    @Provide()
    public globalState: GlobalState = globalState;

    private showToast = false;
    private toastSubscription = new Subscription();

    public created(): void {
        this.toastSubscription = this.globalState.toastObservable.subscribe((toast) => {
            this.showToast = toast !== null;
        });
    }

    public beforeDestroy(): void {
        this.toastSubscription.unsubscribe();
    }
}
